import cssModule from "@vercel/turbopack-next/internal/font/google/cssmodule.module.css?{%22path%22:%22page.tsx%22,%22import%22:%22Great_Vibes%22,%22arguments%22:[{%22subsets%22:[%22latin%22],%22weight%22:%22400%22}],%22variableName%22:%22greatVibes%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'Great Vibes', 'Great Vibes Fallback'",
        fontWeight: 400,
fontStyle: "normal",

    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
